/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GeoPoint } from './GeoPoint';
import {
  GeoPointFromJSON,
  GeoPointFromJSONTyped,
  GeoPointToJSON,
  GeoPointToJSONTyped,
} from './GeoPoint';

/**
 *
 * @export
 * @interface NewDeliveryRequest
 */
export interface NewDeliveryRequest {
  /**
   *
   * @type {string}
   * @memberof NewDeliveryRequest
   */
  type?: string;
  /**
   *
   * @type {string}
   * @memberof NewDeliveryRequest
   */
  recipientName?: string;
  /**
   *
   * @type {string}
   * @memberof NewDeliveryRequest
   */
  contactNumber?: string;
  /**
   *
   * @type {Date}
   * @memberof NewDeliveryRequest
   */
  date?: Date;
  /**
   *
   * @type {string}
   * @memberof NewDeliveryRequest
   */
  preferredTime?: string;
  /**
   *
   * @type {string}
   * @memberof NewDeliveryRequest
   */
  deliveryLocation?: string;
  /**
   *
   * @type {GeoPoint}
   * @memberof NewDeliveryRequest
   */
  deliveryCoordinates?: GeoPoint;
  /**
   *
   * @type {string}
   * @memberof NewDeliveryRequest
   */
  zone?: string;
  /**
   *
   * @type {string}
   * @memberof NewDeliveryRequest
   */
  status?: string;
  /**
   * Delivery fee amount
   * @type {number}
   * @memberof NewDeliveryRequest
   */
  amount?: number;
  /**
   * Total value of packages being delivered
   * @type {number}
   * @memberof NewDeliveryRequest
   */
  packageTotal?: number;
  /**
   * Combined total of package value and delivery fee
   * @type {number}
   * @memberof NewDeliveryRequest
   */
  grandTotal?: number;
  /**
   *
   * @type {string}
   * @memberof NewDeliveryRequest
   */
  notes?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof NewDeliveryRequest
   */
  packages?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof NewDeliveryRequest
   */
  paymentMethod?: string;
  /**
   *
   * @type {string}
   * @memberof NewDeliveryRequest
   */
  referenceNumber?: string;
  /**
   *
   * @type {Date}
   * @memberof NewDeliveryRequest
   */
  createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof NewDeliveryRequest
   */
  updatedAt?: Date;
  /**
   *
   * @type {number}
   * @memberof NewDeliveryRequest
   */
  courierId?: number;
  /**
   *
   * @type {number}
   * @memberof NewDeliveryRequest
   */
  customerId?: number;
  /**
   *
   * @type {number}
   * @memberof NewDeliveryRequest
   */
  deliveryLocationId?: number;
}

/**
 * Check if a given object implements the NewDeliveryRequest interface.
 */
export function instanceOfNewDeliveryRequest(
  value: object
): value is NewDeliveryRequest {
  return true;
}

export function NewDeliveryRequestFromJSON(json: any): NewDeliveryRequest {
  return NewDeliveryRequestFromJSONTyped(json, false);
}

export function NewDeliveryRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): NewDeliveryRequest {
  if (json == null) {
    return json;
  }
  return {
    type: json['type'] == null ? undefined : json['type'],
    recipientName:
      json['recipientName'] == null ? undefined : json['recipientName'],
    contactNumber:
      json['contactNumber'] == null ? undefined : json['contactNumber'],
    date: json['date'] == null ? undefined : new Date(json['date']),
    preferredTime:
      json['preferredTime'] == null ? undefined : json['preferredTime'],
    deliveryLocation:
      json['deliveryLocation'] == null ? undefined : json['deliveryLocation'],
    deliveryCoordinates:
      json['deliveryCoordinates'] == null
        ? undefined
        : GeoPointFromJSON(json['deliveryCoordinates']),
    zone: json['zone'] == null ? undefined : json['zone'],
    status: json['status'] == null ? undefined : json['status'],
    amount: json['amount'] == null ? undefined : json['amount'],
    packageTotal: json['packageTotal'] == null ? undefined : json['packageTotal'],
    grandTotal: json['grandTotal'] == null ? undefined : json['grandTotal'],
    notes: json['notes'] == null ? undefined : json['notes'],
    packages: json['packages'] == null ? undefined : json['packages'],
    paymentMethod:
      json['paymentMethod'] == null ? undefined : json['paymentMethod'],
    referenceNumber:
      json['referenceNumber'] == null ? undefined : json['referenceNumber'],
    createdAt:
      json['createdAt'] == null ? undefined : new Date(json['createdAt']),
    updatedAt:
      json['updatedAt'] == null ? undefined : new Date(json['updatedAt']),
    courierId: json['courierId'] == null ? undefined : json['courierId'],
    customerId: json['customerId'] == null ? undefined : json['customerId'],
    deliveryLocationId:
      json['deliveryLocationId'] == null
        ? undefined
        : json['deliveryLocationId'],
  };
}

export function NewDeliveryRequestToJSON(json: any): NewDeliveryRequest {
  return NewDeliveryRequestToJSONTyped(json, false);
}

export function NewDeliveryRequestToJSONTyped(
  value?: NewDeliveryRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value['type'],
    recipientName: value['recipientName'],
    contactNumber: value['contactNumber'],
    date: value['date'] == null ? undefined : value['date'].toISOString(),
    preferredTime: value['preferredTime'],
    deliveryLocation: value['deliveryLocation'],
    deliveryCoordinates: GeoPointToJSON(value['deliveryCoordinates']),
    zone: value['zone'],
    status: value['status'],
    amount: value['amount'],
    packageTotal: value['packageTotal'],
    grandTotal: value['grandTotal'],
    notes: value['notes'],
    packages: value['packages'],
    paymentMethod: value['paymentMethod'],
    referenceNumber: value['referenceNumber'],
    createdAt:
      value['createdAt'] == null ? undefined : value['createdAt'].toISOString(),
    updatedAt:
      value['updatedAt'] == null ? undefined : value['updatedAt'].toISOString(),
    courierId: value['courierId'],
    customerId: value['customerId'],
    deliveryLocationId: value['deliveryLocationId'],
  };
}
